import { evidenceFiles } from '@/mocks/home';
import SectionHeading from '@/components/feature/SectionHeading';

export default function Evidence() {
  return (
    <section id="archive" className="bg-background-950 py-14 md:py-20">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div className="max-w-2xl">
            <div className="flex items-center gap-2.5">
              <span className="w-6 h-px bg-accent-400" />
              <span className="text-xs tracking-[0.24em] text-accent-400 font-medium">EVIDENCE ARCHIVE</span>
            </div>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-background-50 leading-tight">
              实锤档案 · 逐条校验
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-300 leading-relaxed">
              每一份材料都标注类型、日期与校验状态。标注「已校验」代表至少两条独立信源互相印证，
              标注「待核实」则仍在交叉比对中。
            </p>
          </div>
          <div className="flex items-center gap-6 shrink-0">
            <div>
              <p className="font-heading text-2xl md:text-3xl text-background-50">{evidenceFiles.length}</p>
              <p className="text-xs text-background-400 mt-1">份材料在档</p>
            </div>
            <div className="w-px h-10 bg-background-800" />
            <div>
              <p className="font-heading text-2xl md:text-3xl text-accent-400">
                {evidenceFiles.filter((f) => f.verified).length}
              </p>
              <p className="text-xs text-background-400 mt-1">份已校验</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {evidenceFiles.map((file) => (
            <a
              key={file.id}
              href="#timeline"
              className="group flex gap-4 p-4 md:p-5 rounded-lg bg-background-900 border border-background-800 hover:border-accent-500 transition-colors"
            >
              <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-background-800 text-accent-400">
                <i className={`${file.icon} text-xl`} />
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-[11px] text-background-400">{file.type} · {file.date}</span>
                  <span
                    className={`shrink-0 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] ${
                      file.verified
                        ? 'bg-accent-500/15 text-accent-400'
                        : 'bg-background-800 text-background-400'
                    }`}
                  >
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className={`text-[11px] ${file.verified ? 'ri-checkbox-circle-fill' : 'ri-time-line'}`} />
                    </span>
                    {file.verified ? '已校验' : '待核实'}
                  </span>
                </div>
                <h3 className="mt-1.5 font-heading font-semibold text-base text-background-50 group-hover:text-accent-400 transition-colors">
                  {file.title}
                </h3>
                <p className="mt-1 text-xs text-background-400 leading-relaxed line-clamp-2">{file.desc}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 p-5 rounded-lg bg-background-900 border border-background-800">
          <p className="text-sm text-background-300 text-center sm:text-left">
            手上有新线索？匿名投稿通道 7×24 小时开放，我们会对信源做脱敏处理。
          </p>
          <a
            href="#subscribe"
            className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-send-plane-line text-base" />
            </span>
            匿名提供线索
          </a>
        </div>
      </div>
    </section>
  );
}